import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "./axios";

// GET /api/cards - Tüm kartları listele
export const getAllCards = createAsyncThunk(
  "card/getAllCards",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/cards");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch cards"
      );
    }
  }
);

// POST /api/cards - Yeni kart ekle
export const createCard = createAsyncThunk(
  "card/createCard",
  async (cardData, { rejectWithValue }) => {
    try {
      console.log("Sending card data to API:", cardData);
      const response = await api.post("/cards", cardData);
      console.log("API response:", response.data);
      return response.data;
    } catch (error) {
      console.error("API error:", error.response?.data || error.message);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to create card"
      );
    }
  }
);

// GET /api/cards/:id - Tek kart getir
export const getCard = createAsyncThunk(
  "card/getCard",
  async (cardId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/cards/${cardId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Failed to fetch card"
      );
    }
  }
);

// PUT /api/cards/:id - Kart güncelle
export const updateCard = createAsyncThunk(
  "card/updateCard",
  async ({ id, updates }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/cards/${id}`, updates);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to update card"
      );
    }
  }
);

// DELETE /api/cards/:id - Kart sil
export const deleteCard = createAsyncThunk(
  "card/deleteCard",
  async (cardId, { rejectWithValue }) => {
    try {
      await api.delete(`/cards/${cardId}`);
      return cardId; // Return the deleted card ID
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to delete card"
      );
    }
  }
);

// PATCH /api/cards/:id/toggle - Aktif/Pasif değiştir
export const toggleCardStatus = createAsyncThunk(
  "card/toggleCardStatus",
  async (cardId, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/cards/${cardId}/toggle`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to toggle card status"
      );
    }
  }
);

// PATCH /api/cards/:id/activate - Kartı aktif et (diğerlerini pasif yap)
export const activateCard = createAsyncThunk(
  "card/activateCard",
  async (cardId, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/cards/${cardId}/activate`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to activate card"
      );
    }
  }
);

// PATCH /api/cards/:id/toggle-low - Toggle low amount activation
export const toggleLowAmountCard = createAsyncThunk(
  "card/toggleLowAmountCard",
  async (cardId, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/cards/${cardId}/toggle-low`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to toggle low amount activation"
      );
    }
  }
);

// PATCH /api/cards/:id/toggle-high - Toggle high amount activation
export const toggleHighAmountCard = createAsyncThunk(
  "card/toggleHighAmountCard",
  async (cardId, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/cards/${cardId}/toggle-high`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to toggle high amount activation"
      );
    }
  }
);

// PATCH /api/cards/:id/set-threshold - Set threshold amount
export const setThresholdAmount = createAsyncThunk(
  "card/setThresholdAmount",
  async ({ cardId, thresholdAmount }, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/cards/${cardId}/set-threshold`, {
        thresholdAmount,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to set threshold amount"
      );
    }
  }
);

// GET /api/cards/active - Get all active cards
export const getActiveCards = createAsyncThunk(
  "card/getActiveCards",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/cards/active");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch active cards"
      );
    }
  }
);

// GET /api/cards/active-for-amount/:amount/:traderId - Get active card for specific amount and trader
export const getActiveCardForAmount = createAsyncThunk(
  "card/getActiveCardForAmount",
  async ({ amount, traderId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/cards/active-for-amount/${amount}/${traderId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch active card for amount"
      );
    }
  }
);
